import * as uf from '%/functions';
const ShopCategoryList = (props) => {

  const {
    list
  } = props;

  if (!list?.length)
    return (
      <>
        <div role="listitem" className="w-dyn-item"><a
          href="/categories/tactical-%26-duty-gear"
          className="nav-link-dropdown w-inline-block" tabIndex="0">
          <div>Tactical &amp; Duty Gear</div>
        </a></div>
        <div role="listitem" className="w-dyn-item"><a
          href="/categories/emergency-lights"
          className="nav-link-dropdown w-inline-block" tabIndex="0">
          <div>Emergency Lights</div>
        </a></div>
        <div role="listitem" className="w-dyn-item"><a
          href="/categories/vehicle-equipment"
          className="nav-link-dropdown w-inline-block" tabIndex="0">
          <div>Vehicle Equipment</div>
        </a></div>
        <div role="listitem" className="w-dyn-item"><a
          href="/categories/apparel/"
          className="nav-link-dropdown w-inline-block" tabIndex="0">
          <div>Apparel</div>
        </a></div>
        <div role="listitem" className="w-dyn-item">
          <a
            href="/categories/body-armor/"
            className="nav-link-dropdown w-inline-block" tabIndex="0">
            <div>Body Armor</div>
          </a>
        </div>
        <div role="listitem" className="w-dyn-item">
          <a
            href="/categories/turnkey-vehicles/"
            className="nav-link-dropdown w-inline-block" tabIndex="0">
            <div>Turnkey Vehicles</div>
          </a>
        </div>
        </>
    )

  return (<>
    {list.map(each => (
      <div 
      key={each?.id}
      role="listitem" className="w-dyn-item">
        <a
          href={`/categories/${uf.kebabCase(each.name)}`}
          className="nav-link-dropdown w-inline-block" tabIndex="0">
          <div>{each.name}</div>
        </a>
      </div>

    ))}
  </>)



}


export default ShopCategoryList;